<section id="login">
    <div class="cnt">
        <article class="container ingreso login__form">
            <div id="login-box"></div>
        </article>
    </div>
</section>